<template>
    <div>
        <div class="content-box" style="padding-bottom: 20px;">
            <el-table
                :data="res_list"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :cell-class-name="cellClassName"
                style="width: 100%"
                :max-height="tableMaxHeight"
            >
                <el-table-column
                    v-for="(field,index) in resColumns"
                    :key="field.name+'-'+index"
                    :prop="field.name"
                    :label="field.label"
                >
                    <template slot="header" slot-scope="scope">
                        <span v-if="!field.title">{{field.label}}</span>
                        <el-tooltip v-else effect="dark" :content="field.title" placement="top">
                            <span class="pointer">{{field.label}} <i class="el-icon-question"></i></span>
                            <div slot="content" style="max-width: 300px;line-height: 20px;">{{field.title}}</div>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <HoverEllipsisTips :text="scope.row[field.name]||'-'"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
<!--        <p class="dialog-footer tac mt20">-->
<!--            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>-->
<!--            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>-->
<!--        </p>-->
    </div>
</template>

<script>

import {cloneDeep} from "lodash";
import HoverEllipsisTips from "@/views/basicInfoManagement/tagManagement/components/hoverEllipsis.vue";

export default {
    name: "previewTalbeModal",
    components: {HoverEllipsisTips},
    props:['cbs', 'columns', 'list'],
    data(){
        return {
            include_list: ['account_name', 'account_id', 'app_status', 'account_status', 'company_name', 'bloc_name'], //投放媒体、推广名称、账户名称、账户ID、账户状态、客户名称、集团名称
            resColumns: [],
            cacha_list: [
                {
                    name: 'account_name',
                    label: '账户名称',
                },
                {
                    name: 'account_id',
                    label: '账户Id',
                },
                {
                    name: 'account_status',
                    label: '账户状态',
                },
                {
                    name: 'app_status',
                    label: '投放状态'
                }
            ],
            tableMaxHeight: 0,
            res_list: []
        }
    },
    // watch:{
    //   'columns': {
    //       handler(n){
    //           // 产品的时候 特殊处理
    //           let deep_list = cloneDeep(this.columns)
    //           let res_list = []  //按前端自定义排序走
    //           this.include_list.forEach(item=>{
    //               deep_list.forEach(itemc=>{
    //                   if(itemc.name == item && (itemc.name != 'plat_id' && itemc.name != 'subproject_name')) {
    //                       res_list.push(itemc)
    //                   }
    //               })
    //           })
    //           this.resColumns = res_list
    //       },
    //       immediate: true
    //   }
    // },
    mounted(){
        let deep_list = cloneDeep(this.columns)
        let res_list = []  //按前端自定义排序走
        this.include_list.forEach(item=>{
            deep_list.forEach(itemc=>{
                if(itemc.name == item) {
                    res_list.push(itemc)
                }
            })
        })
        this.resColumns = res_list
        this.res_list = []

        let maxLen = this.list[0].account_name ? this.list[0].account_name.length : 0
        let tableData = []
        for(let i=0;i<maxLen;i++){
            let tempObj = {}
            this.resColumns.forEach(item=>{
                tempObj[item.name] = this.list[0][item.name][i]
            })
            tableData.push(tempObj)
        }

        this.res_list = tableData

        this.$nextTick(()=>{
            this.tableMaxHeight = parseInt(document.body.clientHeight / 2)
            console.log('this.tableMaxHeight', this.tableMaxHeight)
        })

    },
    methods:{
        submitModal(){
            this.cbs.onSubmit()
        },
        hideModal(){
            this.$emit('close');
        },
        // 2.16.1.0.0 标签管理显示上级对应信息 全选与取消

        // 表格列class添加
        cellClassName({row, column, rowIndex, columnIndex}) {
            if(column.property == 'account_id' || column.property == 'account_name' || column.property == 'account_status' || column.property == 'app_status' || column.property == 'company_name' || column.property == 'bloc_name') {
                return 'cell_vertical-align-top'
            }
        },
    }
}
</script>
<style scoped lang="scss">
.expand_table_border{
    margin-left: -10px;
    margin-right: -10px;
    .borderBottom{
        border-bottom: 1px solid #EBEEF5;
        padding-top: 4px;
        padding-bottom: 4px;
        padding-left: 10px;
        max-height: 40px;
        overflow-y: hidden;
        &:last-child{
            border-bottom: none;
        }
    }
}
.data-list{
    ::v-deep.cell_vertical-align-top.el-table__cell{
        vertical-align: top;
    }

}
</style>
<style lang="scss">
.define_tips_projectManager{
    max-width: 400px;
    .define_tips_items{
        margin-top: 5px;
        .define_tips_items_child{
            margin-top: 3px;
        }
        &:first-child{
            margin-top: 0;
        }
    }
}
</style>
